$(document).ready(function() {
        //Horizontal Tab
        $('#product_info_tabs').easyResponsiveTabs({
            type: 'default', //Types: default, vertical, accordion
            width: 'auto', //auto or any width like 600px
            fit: true, // 100% fit in a container
            tabidentify: 'hor_1', // The tab groups identifier
            
        });
});

/**
 * Mirrors the cart drawer's open/closed state to a `cart-opened` class on
 * `<body>` so that other elements (e.g. the Gorgias chat bubble) can be
 * conditionally styled while the cart is visible. The cart drawer is the
 * "right sidebar" of the theme's off-canvas system, shared with non-cart
 * views (pickup, collection-filter, product-form), so the class is only
 * applied when both the off-canvas state is on the right side AND the
 * right sidebar's active view is `cart`.
 *
 * @returns {void}
 */
$(document).ready(function () {
	var viewport = document.querySelector('.off-canvas--viewport');
	var rightSidebar = document.querySelector('.off-canvas--right-sidebar');

	if (!viewport || !rightSidebar) {
		return;
	}

	/**
	 * Adds or removes `.cart-opened` on `<body>` based on the current
	 * off-canvas state and the right sidebar's active view.
	 *
	 * @returns {void}
	 */
	function syncCartOpenedClass() {
		var state = viewport.getAttribute('data-off-canvas--state') || '';
		var view = rightSidebar.getAttribute('data-active') || '';
		var cartIsOpen = state.indexOf('right--') === 0 && view === 'cart';

		document.body.classList.toggle('cart-opened', cartIsOpen);
	}

	new MutationObserver(syncCartOpenedClass).observe(viewport, {
		attributes: true,
		attributeFilter: ['data-off-canvas--state']
	});

	new MutationObserver(syncCartOpenedClass).observe(rightSidebar, {
		attributes: true,
		attributeFilter: ['data-active']
	});

	syncCartOpenedClass();
});

/**
 * Mirrors the mobile-nav tray's open/closed state to a `mobile-nav-opened`
 * class on `<body>` so that other elements (e.g. the Gorgias chat bubble)
 * can be conditionally styled while the tray is visible. The mobile nav
 * tray is the "left sidebar" of the theme's off-canvas system and, unlike
 * the right sidebar, is dedicated to the menu view (see
 * `CoreOffCanvas.prototype.focusOnView` in `assets/theme.js` — the left
 * sidebar is hardcoded to `data-view='menu'`), so the class is gated on
 * the viewport state alone.
 *
 * @returns {void}
 */
$(document).ready(function () {
	var viewport = document.querySelector('.off-canvas--viewport');

	if (!viewport) {
		return;
	}

	/**
	 * Adds or removes `.mobile-nav-opened` on `<body>` based on whether
	 * the off-canvas viewport state begins with `left--` (i.e. the mobile
	 * nav tray is opening, opened, or closing).
	 *
	 * @returns {void}
	 */
	function syncMobileNavOpenedClass() {
		var state = viewport.getAttribute('data-off-canvas--state') || '';
		var mobileNavIsOpen = state.indexOf('left--') === 0;

		document.body.classList.toggle('mobile-nav-opened', mobileNavIsOpen);
	}

	new MutationObserver(syncMobileNavOpenedClass).observe(viewport, {
		attributes: true,
		attributeFilter: ['data-off-canvas--state']
	});

	syncMobileNavOpenedClass();
});

// GC-204: the product page gallery starts at DOM ready, not window load, so swiping works before every photo
// has arrived (its slides are sized up front, main-product-gold.liquid). Every other slider keeps the
// window-load start: the old product section's photos have no size until they load, and at DOM ready this
// would reach the cart drawer's carousel before cart-recommendations.js does.
$(function() {
  startProductSliders($('.gold-main-media-stage .flexslider'));
});
$(window).load(function() {
  startProductSliders($('.flexslider').not('.gold-main-media-stage .flexslider'));
  // GC-204: the later gallery photos are lazy so the first one gets the bandwidth while the page loads; now
  // fetch them all, so a swipe never lands on a slide that only starts downloading then.
  $('.gold-main-media-stage .slides > li > img[loading="lazy"]').attr('loading', 'eager');
});

function startProductSliders($sliders) {
  $sliders.flexslider({
    animation: "slide",
    directionNav: false,
    controlNav: "thumbnails",
    smoothHeight: true,
    // GC-133: no auto-advance on phones. Below 768px Add to Cart sits under the gallery, and smoothHeight sizes
    // the gallery to each slide (a portrait video is ~150px taller than a photo), so every 7s turn moved the
    // button with no tap. Swipes, thumbnails and dots still change slides. ponytail: read once at load, so a
    // page loaded at 768px+ and then turned to portrait keeps the autoplay; pause on a matchMedia change if that matters.
    slideshow: !window.matchMedia('(max-width: 767px)').matches,
    // GC-204: the loop's clone slides only flash past while the gallery wraps around, so their videos keep the
    // poster and never load; started at DOM ready, a cloned video downloaded the clip again during page load
    // and pushed the load event back ~10 s on slow 4G. Runs in the task that inserts the clones, before any fetch.
    init: function(slider) {
      slider.find('.slides > li.clone video').removeAttr('autoplay').find('source').remove();
    },
    start: function(slider) {
      // Create custom dot navigation
      var dotNav = $('<ol class="custom-dot-nav"></ol>');
      
      slider.find('.slides > li:not(.clone)').each(function(index) {
        var dot = $('<li><button></button></li>');
        if (index === 0) dot.addClass('active');
        
        dot.on('click', function() {
          slider.flexslider(index);
        });
        
        dotNav.append(dot);
      });
      
      slider.append(dotNav);
    },
    after: function(slider) {
      // Update active dot
      $('.custom-dot-nav li').removeClass('active')
        .eq(slider.currentSlide).addClass('active');
    }
  });
}

/**
 * GC-45 — Bud size tooltip on tap.
 * Hover is CSS-only; touch devices (and Safari, which does not focus buttons
 * on click) need a toggle. One delegated listener covers every card, including
 * cards added later by infinite scroll or AJAX.
 */
(function() {
  function closeAll(except) {
    document.querySelectorAll('[data-bud-size-icon].is-open').forEach(function(el) {
      if (el === except) return;
      el.classList.remove('is-open');
      var btn = el.querySelector('.bud-size-icon__btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  // Close on any tap outside an icon. Capture phase, so sections that stop
  // click propagation (e.g. the homepage hero) can't keep a tooltip open.
  document.addEventListener('pointerdown', function(event) {
    if (!event.target.closest || !event.target.closest('[data-bud-size-icon]')) closeAll(null);
  }, true);

  document.addEventListener('click', function(event) {
    var btn = event.target.closest('.bud-size-icon__btn');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var wrap = btn.closest('[data-bud-size-icon]');
    var open = !wrap.classList.contains('is-open');
    closeAll(wrap);
    wrap.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) keepInView(wrap);
  });

  // The tooltip is centred on the icon, which often sits near a screen edge
  // (end of a card's info line, right-aligned PDP row). Slide it back inside.
  function keepInView(wrap) {
    var tip = wrap.querySelector('.bud-size-icon__tip');
    if (!tip) return;
    tip.style.transform = '';
    var rect = tip.getBoundingClientRect();
    var margin = 8;
    var shift = 0;
    if (rect.left < margin) shift = margin - rect.left;
    else if (rect.right > window.innerWidth - margin) shift = window.innerWidth - margin - rect.right;
    if (shift) tip.style.transform = 'translateX(calc(-50% + ' + Math.round(shift) + 'px))';
  }

  document.addEventListener('mouseover', function(event) {
    var wrap = event.target.closest && event.target.closest('[data-bud-size-icon]');
    if (wrap) keepInView(wrap);
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') closeAll(null);
  });
})();
